import React, { useEffect, useState } from "react";
import WebViewProduct from "./WebSection/WebViewProduct";
import MobileViewProduct from "./MobileSection/MobileViewProduct";
import { getProductData } from "utils/LaravelApi/LaravelAPI";
import { useParams } from "react-router-dom";
import { useQuery } from "helpers/helpers";

export default function NewProducto() {
  let query = useQuery();
  const { category } = useParams();

  const [data, setData] = useState({
    id: 0,
    price: 0,
    discount: true,
    discountPrice: 0,
    discountPercentage: 10,
    name: "",
    disableOil: true,
    liters: [],
    description: "",
  });
  const [dataURL, setDataURL] = useState([]);

  useEffect(() => {
    async function go() {
      const { data } = await getProductData(category, query.get("id"));
      data.disableOil = category === 'kit-de-afinacion' ? data.disableOil : true; 
      setData({ ...data, category });
      setDataURL(data.pictures);
    }
    go();
    //eslint-disable-next-line
  }, []);

  if (data === null) return null;
  else
    return (
      <div>
        <WebViewProduct data={data} dataURL={dataURL} />
        <MobileViewProduct data={data} dataURL={dataURL} />
      </div>
    );
}
